import { PropsWithChildren, useCallback } from 'react';

import { HistogramContent, HistogramOverlayRoot, HistogramSlider } from './HistogramOverlay.styled';
import HistogramOverlayTrack from './HistogramOverlayTrack/HistogramOverlayTrack';

interface HistogramOverlayProps {
  min: number;
  max: number;
  value: [number, number];
  onChange: (value: [number, number]) => void;
  step?: number;
  className?: string;
  disabled?: boolean;
}

function HistogramOverlay(props: PropsWithChildren<HistogramOverlayProps>) {
  const { className, onChange, children, ...rest } = props;

  const onChangeValue = useCallback(
    (_: Event, range: number | number[]) => onChange(range as [number, number]),
    [onChange],
  );

  return (
    <HistogramOverlayRoot className={className}>
      <HistogramSlider slots={{ track: HistogramOverlayTrack }} onChange={onChangeValue} {...rest} />

      <HistogramContent>{children}</HistogramContent>
    </HistogramOverlayRoot>
  );
}

export default HistogramOverlay;
